import React from 'react';
import BaseLogo from '../../assets/images/chains/BaseLogo.svg';
import EthLogo from '../../assets/images/chains/ethereum.png';
import { Box, SxProps, Theme } from '@mui/material';
import { formatNumber } from '../../shared/utils/Formatter';
import { ethers } from 'ethers';

interface VirtualBalanceProp {
  value: BigInt;
  isVirtual?: boolean;
  isEthereum?: boolean;
}

const pillStyle: SxProps<Theme> = {
  borderRadius: '8px',
  background: '#EDF9FB',
  color: 'primary.main',
  display: 'inline-flex',
  padding: '.2rem .5rem',
  gap: '.5rem',
  fontSize: '1rem',
  whiteSpace: 'nowrap',
  alignItems: 'center',
};

const VirtualBalanceChip: React.FC<VirtualBalanceProp> = (props) => {
  return (
    <Box sx={pillStyle}>
      <img
        src={props.isEthereum ? EthLogo : BaseLogo}
        alt="polygon"
        style={{
          width: '16px',
          height: '16px',
        }}
      />
      <div>
        <strong>
          {formatNumber(Number(ethers.formatEther(props.value.toString())))}
        </strong>{' '}
        {props.isVirtual ? '$VIRTUAL' : '$xVIRTUAL'}
      </div>
    </Box>
  );
};

export default VirtualBalanceChip;
